import React from 'react';
import { motion } from 'framer-motion';
const desserts = [{
  name: 'Galletas de la s',
  desc: 'Traditional Mexican sweet bread, baked fresh daily.',
  img: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=800&q=80'
}, {
  name: 'Fudge Brownies',
  desc: 'Rich, dense chocolate brownies with a crackly top.',
  img: 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?auto=format&fit=crop&w=800&q=80'
}, {
  name: 'House Cookies',
  desc: 'Soft-baked chocolate chip and oatmeal raisin.',
  img: 'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?auto=format&fit=crop&w=800&q=80'
}, {
  name: 'Cheesecake Slice',
  desc: 'Creamy classic cheesecake with seasonal fruit topping.',
  img: 'https://images.unsplash.com/photo-1533134242443-d4fd215305ad?auto=format&fit=crop&w=800&q=80'
}, {
  name: 'Banana Bread',
  desc: 'Moist, spiced banana bread perfect with a hot latte.',
  img: 'https://images.unsplash.com/photo-1596522430488-825501861033?auto=format&fit=crop&w=800&q=80'
}, {
  name: 'Morning Muffins',
  desc: 'Blueberry and bran muffins to start your day right.',
  img: 'https://images.unsplash.com/photo-1607958996333-41aef7caefaa?auto=format&fit=crop&w=800&q=80'
}];
export function Desserts() {
  return <section id="desserts" className="py-24 bg-white" data-id="element-47">
      <div className="max-w-7xl mx-auto px-6" data-id="element-48">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-49">
          <div data-id="element-50">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-serif font-bold text-hope-brown mb-4" data-id="element-51">
              Sweet Treats
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg text-hope-brown/70 max-w-xl" data-id="element-52">
              The perfect pairing for your coffee. Selection varies daily.
            </motion.p>
          </div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="px-4 py-2 bg-hope-cream rounded-full text-sm font-medium text-hope-brown border border-hope-mustard/20" data-id="element-53">
            Ask in store for today's selection & prices
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-54">
          {desserts.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="group rounded-3xl overflow-hidden bg-hope-cream border border-hope-mustard/10 hover:shadow-soft transition-all duration-300" data-id="element-55">
              <div className="aspect-[4/3] overflow-hidden" data-id="element-56">
                <img src={item.img} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-57" />
              </div>
              <div className="p-6" data-id="element-58">
                <h3 className="text-xl font-serif font-bold text-hope-brown mb-2" data-id="element-59">
                  {item.name}
                </h3>
                <p className="text-hope-brown/70 text-sm leading-relaxed" data-id="element-60">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}